<template>
  <div class="vhp-loading">
    로딩중
  </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    mounted() {

    },

}
</script>

<style lang="scss" src="./vhpLoading.scss"></style>